'use client';

import { Grid2 } from '@mui/material';
import { Footer } from './footer/Footer';
import { TopBar } from './TopBar';
import { useCorporateStore } from '@/infrastructure/zustand/corporateStoreProvider';
import type { ReactNode } from 'react';
import { useLanguageStore } from '@/infrastructure/zustand/languageStoreProvider';
import type { CampaignConfig, IndexConfig } from '@/modules/config.interface';

export const MainContainer = ({ children, config }: { children: ReactNode; config: IndexConfig | CampaignConfig }) => {
	const topBar = useCorporateStore((state) => state.metadata.topBar);
	const merchantLogo = useCorporateStore((state) => state.merchant.logo);
	const currentLangCode = useLanguageStore((state) => state.currentLangCode);

	return (
		<>
			{config.site === 'actitudsolidaria' ? null : config.site === 'ametllerorigen' &&
			  config.page === 'home' ? null : topBar ? (
				<TopBar
					merchantLogoSrc={
						config.topBarLogoSrc?.(
							typeof config.merchantLogo === 'string'
								? (config.merchantLogo ?? merchantLogo)
								: (config.merchantLogo?.(currentLangCode) ?? merchantLogo),
						) ??
						(typeof config.merchantLogo === 'string'
							? (config.merchantLogo ?? merchantLogo)
							: (config.merchantLogo?.(currentLangCode) ?? merchantLogo))
					}
				>
					{config.topBarExtraContent}
				</TopBar>
			) : null}
			<Grid2
				container
				direction="row"
				sx={{
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center',
					backgroundSize: 'cover',
				}}
			>
				{children}
			</Grid2>
			<Footer config={config} />
		</>
	);
};
